<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Organisation de l'équipe officinale">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="6">
              <span class="subtitle-1 text-left font-weight-bold">
                &#187; Etes-vous en règle avec l’arrêté annuel relatif au nombre
                de pharmaciens dont les titulaires d’officine doivent se faire
                assister en raison de l’importance de leur chiffre d’affaires ?
              </span></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.regleArreteAnnuel"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="regleArreteAnnuel"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="regleArreteAnnuel"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "Partie5",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    textRules: [v => !!v || "Ce champ est requis"],
    radioRules: [v => v !== null || "Ce champ est requis"]
  }),
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>
